/**
 * Created by shegj on 2018-04-03.
 *  UrlUtil
 */

"use strict";

import Constants from '../common/Constants';

const getUrl = (url) => {
  const curTime = Date.now();
  const serverURL = Constants.serverURL;
  const curJsSessionId = localStorage.getItem("curJsSessionId");
  const domain = localStorage.getItem("domain");
  let defaultLangValue = localStorage.getItem("defaultLangValue");
  if(!defaultLangValue){
    defaultLangValue = "zh_CN";
  }
  if (url.indexOf('?') == -1) {
    if(!curJsSessionId){
      return `${serverURL}${url}?_=${curTime}&language=${defaultLangValue}&_locale=${defaultLangValue}${domain ? `&ssly=${domain}` : ''}`;
    }
    return `${serverURL}${url}?_=${curTime}&curJsSessionId=${curJsSessionId}&language=${defaultLangValue}&_locale=${defaultLangValue}${domain ? `&ssly=${domain}` : ''}`;
  }
  if(!curJsSessionId){
    return `${serverURL}${url}&_=${curTime}&language=${defaultLangValue}&_locale=${defaultLangValue}${domain ? `&ssly=${domain}` : ''}`;
  }
  return `${serverURL}${url}&_=${curTime}&&curJsSessionId=${curJsSessionId}&language=${defaultLangValue}&_locale=${defaultLangValue}${domain ? `&ssly=${domain}` : ''}`;
};

export default getUrl;



// WEBPACK FOOTER //
// ./src/utils/UrlUtil.js